module.exports = __webpack_public_path__ + "static/media/order.bac855a2.jpg";